var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    !_vm.hidden
      ? _c(
          "div",
          { staticClass: "vuestic-alert alert", class: _vm.alertClass },
          [
            _vm._t("default"),
            _vm.withCloseBtn
              ? _c("i", {
                  staticClass: "fa fa-close alert-close",
                  on: {
                    click: function ($event) {
                      return _vm.hide()
                    },
                  },
                })
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }